export const audioAdvertisingAvailability = (state) => {
  return state.audioAdvertisingAvailability || process.env.NODE_ENV === "development"
}
